// removed by extract-text-webpack-plugin
module.exports = {"container":"_33ORMsLp19iBNamFKQfrJl","barLeft":"nNn9CsiF3QpqD1nOd8K0x","iconTop":"_1_D0mVXCnD_VCbE5Jda4gX","textV":"_1BwwT6rtugtbaFQtzotTe5","actionIcon":"_1t5xPgrL6lN4pJXwO2YkWj","content":"_2lnUT98aP24ScvUn5D8b6q","date":"_3iyntLpNQBqfdTzhJffFsN","title":"_7jVm9sX-MhkYICge08YEb","location":"_14-0bwxFkfVYHR_Bk_lXfL","city":"_1NRJ2Wy813sZFjciMhZNI1"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/molecules/BoxEvent/style.css
// module id = 493
// module chunks = 38